var moduleMap = {
	"./config-data": () => {
		return Promise.all([__webpack_require__.e(3685), __webpack_require__.e(7760), __webpack_require__.e(7015)]).then(() => (() => ((__webpack_require__(67015)))));
	},
	"./core-library-store": () => {
		return Promise.all([__webpack_require__.e(3685), __webpack_require__.e(7760), __webpack_require__.e(8555)]).then(() => (() => ((__webpack_require__(48555)))));
	},
	"./event-bus": () => {
		return Promise.all([__webpack_require__.e(8416), __webpack_require__.e(1452), __webpack_require__.e(1821)]).then(() => (() => ((__webpack_require__(61821)))));
	},
	"./useOpenWindow": () => {
		return Promise.all([__webpack_require__.e(8416), __webpack_require__.e(3685), __webpack_require__.e(7760), __webpack_require__.e(7015), __webpack_require__.e(6060)]).then(() => (() => ((__webpack_require__(46060)))));
	},
	"./formatUrl": () => {
		return __webpack_require__.e(6594).then(() => (() => ((__webpack_require__(36594)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});